import React from "react";
import PropTypes from "prop-types";
import Overlay from "components/Overlay";
import { RateScoreDisplay } from "components/Missions/Applicants";
import Score from "components/Score";
import { convertToPercent } from "utils";

/**
 * ApplicantRateScore
 *
 * @param {Object} hourlyRateData
 * @param {Number} rateScore
 */
const ApplicantRateScore = ({ hourlyRateData, rateScore }) => (
  <Overlay
    overlay={<RateScoreDisplay rateData={hourlyRateData} currency={hourlyRateData?.currency} />}
    trigger={<Score score={Number(rateScore) * 100}>{convertToPercent(rateScore)}</Score>}
    placement="top"
  />
);

ApplicantRateScore.propTypes = {
  hourlyRateData: PropTypes.object,
  rateScore: PropTypes.number,
};

export default ApplicantRateScore;
